var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#231F20",
    cx: 32,
    cy: 14,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M4,25h56c1.794,0,3.368-1.194,3.852-2.922c0.484-1.728-0.242-3.566-1.775-4.497l-28-17 C33.438,0.193,32.719,0,32,0s-1.438,0.193-2.076,0.581l-28,17c-1.533,0.931-2.26,2.77-1.775,4.497C0.632,23.806,2.206,25,4,25z  M32,9c2.762,0,5,2.238,5,5s-2.238,5-5,5s-5-2.238-5-5S29.238,9,32,9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 27,
    fill: "#231F20",
    width: 8,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 27,
    fill: "#231F20",
    width: 8,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 27,
    fill: "#231F20",
    width: 8,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 27,
    fill: "#231F20",
    width: 8,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M4,58h56c0-2.209-1.791-4-4-4H8C5.791,54,4,55.791,4,58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M63.445,60H0.555C0.211,60.591,0,61.268,0,62v2h64v-2C64,61.268,63.789,60.591,63.445,60z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankSvgrepoCom);
export default __webpack_public_path__ + "static/media/bank-svgrepo-com.85db29c197f852b49979e45e6a9c9a3b.svg";
export { ForwardRef as ReactComponent };